import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

const useStoreProductTypes = ({ storeId, doInitialRequest }) => {
  const { data: productTypes, loading: fetchingProductTypes } = useFetch(
    () => configurationServices.getStoreProductTypes({ storeId }),
    {
      doInitialRequest: doInitialRequest,
    }
  )

  return {
    productTypes: productTypes || [],
    fetchingProductTypes,
  }
}

export default useStoreProductTypes
